import { paths } from 'config'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'

const routes: ModuleRoute[] = [
  {
    path: paths.confirmBooking,
    exact: true,
    public: true,
    layoutSettings: {
      contentProps: {
        style: { justifyContent: 'center', alignItems: 'center' },
      },
      drawerProps: { hidden: true },
      topbarProps: { hidden: true },
    },
    component: Loadable({
      component: () => import('./pages/BookingConfirmation'),
    }),
  },
]

export default routes
